import { createContext, useContext } from 'react';

/**
 * Workspace tab actions for pages and the sidebar:
 * { openTab({ page, section, client }), openClientInNewTab(client), canOpenTab }.
 * Null outside the app shell (tests, standalone pages) — callers fall back to
 * their normal same-tab behaviour.
 */
export const WorkspaceTabsContext = createContext(null);

export function useWorkspaceTabsContext() {
  return useContext(WorkspaceTabsContext);
}

/** True for clicks that mean "open in a new tab": Cmd/Ctrl-click or middle-click. */
export function isNewTabClick(event) {
  if (!event) return false;
  return Boolean(event.metaKey || event.ctrlKey || event.button === 1);
}
